'use client';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { sortableItemStyle, draggingItemStyle } from '@/_constants/dnd-kit';

export const useSortableItem = (
  id: string | number,
  customStyle?: React.CSSProperties,
) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const baseStyle = isDragging ? draggingItemStyle : sortableItemStyle;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    ...baseStyle,
    ...customStyle,
  };

  return {
    attributes,
    listeners,
    setNodeRef,
    style,
    isDragging,
  };
};
